import styled from "styled-components";

export const HeaderSearchListSection = styled.div`
  width: 450px;
  background-color: ${({ theme }) => theme.itemBg};
  position: absolute;
  margin-left: 10px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;
